import React from "react";
import ReactDOM from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import "slick-carousel/slick/slick.css";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import "./index.css";
import App from "./App";
import { LanguageProvider } from './components/home/Header/LanguageContext';
import { ContextProvider } from "./contexts/ContextProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <ContextProvider>
    <LanguageProvider>
      <App />
      </LanguageProvider>
      </ContextProvider>
    </PersistGate>
   
  </Provider>
);
